// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
div[data-v-dc001816] {
    display: block;
    width: 100%;
    margin-bottom: 1rem;
    text-align: center;
}
img[data-v-dc001816] {
    width: 100%;
    max-width: 950px;
    background-color: #bebdbd;
    cursor: pointer;
}
.collapsed[data-v-dc001816] {
    overflow: hidden;
    height: 40vh;
}
.collapsed img[data-v-dc001816] {
    display: block;
    margin: 0 auto;
    margin-top: 20vh;
    transform: translateY(-50%);
}
@media print {
div[data-v-dc001816]:not(.printable) {
        display: none !important;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/RecipeView/RecipeImages.vue"],"names":[],"mappings":";AAoCA;IACA,cAAA;IACA,WAAA;IACA,mBAAA;IACA,kBAAA;AACA;AAEA;IACA,WAAA;IACA,gBAAA;IACA,yBAAA;IACA,eAAA;AACA;AAEA;IACA,gBAAA;IACA,YAAA;AACA;AAEA;IACA,cAAA;IACA,cAAA;IACA,gBAAA;IACA,2BAAA;AACA;AAEA;AACA;QACA,wBAAA;AACA;AACA","sourcesContent":["<template>\n    <div\n        v-if=\"$store.state.recipe.image\"\n        :class=\"{\n            collapsed: collapsed,\n            printable: $store.state.recipe.printImage,\n        }\"\n    >\n        <img\n            :alt=\"t('cookbook', 'Recipe image')\"\n            :src=\"$store.state.recipe.imageUrl\"\n            @click=\"toggleCollapsed()\"\n        />\n    </div>\n</template>\n\n<script setup>\nimport { ref } from 'vue';\n\n/**\n * @type {import('vue').Ref<boolean>}\n */\nconst collapsed = ref(true);\n\nconst toggleCollapsed = () => {\n    collapsed.value = !collapsed.value;\n};\n</script>\n\n<script>\nexport default {\n    name: 'RecipeImages',\n};\n</script>\n\n<style scoped>\ndiv {\n    display: block;\n    width: 100%;\n    margin-bottom: 1rem;\n    text-align: center;\n}\n\nimg {\n    width: 100%;\n    max-width: 950px;\n    background-color: #bebdbd;\n    cursor: pointer;\n}\n\n.collapsed {\n    overflow: hidden;\n    height: 40vh;\n}\n\n.collapsed img {\n    display: block;\n    margin: 0 auto;\n    margin-top: 20vh;\n    transform: translateY(-50%);\n}\n\n@media print {\n    div:not(.printable) {\n        display: none !important;\n    }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
